<template>
  <div class="p-4 mx-auto">
    <table class="w-full">
      <tr>
        <th class=" text-left py-2 px-1">Name</th>
        <th class=" text-left py-2 px-1">Email</th>
        <th class=" text-left py-2 px-1">Quiz</th>
        <th class=" text-left py-2 px-1">Score</th>
      </tr>
      <tr
        v-for="(quiz, index) in searchSubmission"
        :key="index"
        :class="index % 2 == 0 ? 'bg-gray-100' : ''"
      >
        <td class="border px-8 py-4">
          {{ quiz.user.first_name }} {{ quiz.user.last_name }}
        </td>
        <td class="border px-8 py-4">{{ quiz.user.email }}</td>
        <td class="border px-8 py-4">{{ quiz.lesson.title }}</td>
        <td class="border px-8 py-4 capitalize">
          {{ quiz.score }}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["search"],
  components: {
    LmsBlueButton: () => import("@/components/general/button"),
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["getQuizResults"]),
    searchSubmission() {
      return this.getQuizResults.filter((quiz) => {
        return (
          quiz.user.first_name.toLowerCase().match(this.search.toLowerCase()) ||
          quiz.user.last_name.toLowerCase().match(this.search.toLowerCase()) ||
          quiz.lesson.title.toLowerCase().match(this.search.toLowerCase())
        );
      });
    },
  },
  created() {
    // this.tenantFetchQuiz();
    this.tenantFetchQuizResult();
  },
  methods: {
    ...mapActions(["tenantFetchQuizResult"]),
  },
};
</script>

<style lang="scss" scoped></style>
